'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("xlsMetadataService", function ($modal, $http, $dialogBox, $q) {
  var popinOptions = {
    controller: "XlsMetadataPopinController",
    template: require("./xlsMetadataPopin.html")
  };
  return {
    /**
     *
     * @param url
     * @param post
     * @param componentUuid identifiant unique du composant (pour les rapports)
     * @param defautConfiguration à true uniquement pour récupérer la configuration par défaut
     * @param hideDocx pour ne pas afficher la colonne docx (si vous ne voule pas permettre l'export pour ce tableau)
     * @returns {*}
     */
    openMetadataPopin: function openMetadataPopin(url, post, componentUuid, defautConfiguration, hideDocx) {
      return $modal.open(_.extend(popinOptions, {
        vars: {
          url: url,
          post: post,
          componentUuid: componentUuid,
          // indique si il s'agit de la configuration par defaut
          defautConfiguration: defautConfiguration,
          hideDocx: hideDocx
        }
      }));
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/xls/metadata/xlsMetadataService.js
// module id = 3029
// module chunks = 13